export const socialsData = {
    github: 'https://github.com/KareemWilson',
    linkedIn: 'https://www.linkedin.com/in/kareem-wilson/',
    instagram: 'https://www.instagram.com/code.afternoon/',
    leetCode: 'https://leetcode.com/kareemmagdywilson/',
    medium: 'https://medium.com/@kareemmagdywilson'
}